import client from './client';

export const listFirefighters = (params) =>
  client.get('/firefighters', { params }).then((r) => r.data);

export const getFirefighter = (id) =>
  client.get(`/firefighters/${id}`).then((r) => r.data);

export const createFirefighter = (data) =>
  client.post('/firefighters', data).then((r) => r.data);

export const updateFirefighter = (id, data) =>
  client.put(`/firefighters/${id}`, data).then((r) => r.data);

export const deleteFirefighter = (id) =>
  client.delete(`/firefighters/${id}`).then((r) => r.data);
